import { useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const mins = (s) => `${Math.round((s || 0) / 60)} menit`;

export default function DataTraining() {
  const [datasets, setDatasets] = useState([]);
  const [name, setName] = useState("");
  const [formFile, setFormFile] = useState(null);
  const [mutasiFile, setMutasiFile] = useState(null);
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  const [pbusy, setPbusy] = useState(false);

  const load = useCallback(() => { api.get("/datasets").then((r) => setDatasets(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return toast.error("Isi nama dataset");
    if (!formFile) return toast.error("Upload file Form/Member");
    setBusy(true);
    const fd = new FormData();
    fd.append("name", name);
    fd.append("form_file", formFile);
    if (mutasiFile) fd.append("mutasi_file", mutasiFile);
    try {
      const { data } = await api.post("/datasets", fd);
      toast.success(`Dataset '${data.name}' dibuat — ${data.form_count} form`);
      setName(""); setFormFile(null); setMutasiFile(null);
      document.getElementById("ds-form-file").value = "";
      const m = document.getElementById("ds-mutasi-file"); if (m) m.value = "";
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const doPreview = async () => {
    if (!formFile) return toast.error("Pilih file Form dulu");
    setPbusy(true);
    const fd = new FormData();
    fd.append("file", formFile);
    try {
      const { data } = await api.post("/datasets/preview", fd);
      setPreview(data);
      if (data.warnings.length) toast.warning(`${data.warnings.length} peringatan kolom`);
      else toast.success(`Mapping OK — ${data.count} form`);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setPbusy(false); }
  };

  const del = async (d) => {
    if (!window.confirm(`Hapus dataset '${d.name}'?`)) return;
    try { await api.delete(`/datasets/${d.id}`); toast.success("Dataset dihapus"); load(); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const dlTemplate = () => {
    const token = localStorage.getItem("token");
    fetch(process.env.REACT_APP_BACKEND_URL + "/api/datasets/template", { headers: { Authorization: `Bearer ${token}`, "X-Site-Id": localStorage.getItem("site_id") || "" } })
      .then((r) => r.blob()).then((b) => {
        const url = URL.createObjectURL(b); const a = document.createElement("a");
        a.href = url; a.download = "form_template.csv"; a.click(); URL.revokeObjectURL(url);
      });
  };

  return (
    <div data-testid="data-training-page">
      <div className="section-head">Data Training — Replay Data Lama</div>
      <div className="import-box" data-testid="dataset-form-box">
        <div style={{ fontSize: 11, color: "#555", marginBottom: 8 }}>
          Buat dataset dari data transaksi lama: <b>file Form/Member</b> (wajib) dan <b>file Mutasi bank/e-wallet</b> (opsional referensi).
          Form muncul ke staff mengikuti selisih waktu asli.{" "}
          <a className="link-blue" onClick={dlTemplate} data-testid="dataset-template">Download contoh format Form CSV</a>
        </div>
        <form onSubmit={submit} data-testid="dataset-form">
          <div className="form-row"><label>Nama Dataset</label>
            <input className="form-input" placeholder="SHIFT 23 AUG 18:00 - 19:00" value={name} onChange={(e) => setName(e.target.value)} data-testid="ds-name" /></div>
          <div className="form-row"><label>File Form / Member</label>
            <input id="ds-form-file" type="file" accept=".csv,.xlsx,.xls" onChange={(e) => setFormFile(e.target.files[0])} data-testid="ds-form-file" /></div>
          <div className="form-row"><label>File Mutasi (opsional)</label>
            <input id="ds-mutasi-file" type="file" accept=".csv,.xlsx,.xls" onChange={(e) => setMutasiFile(e.target.files[0])} data-testid="ds-mutasi-file" /></div>
          <div className="form-row"><label></label>
            <button type="button" className="btn btn-gray" disabled={pbusy} onClick={doPreview} data-testid="ds-preview">Preview Mapping</button>
            <button className="btn btn-primary" disabled={busy} data-testid="ds-submit" style={{ marginLeft: 8 }}>+ Simpan Dataset</button></div>
        </form>
      </div>

      {preview && (
        <div className="import-box" data-testid="dataset-preview" style={{ borderColor: "#2f6fa5" }}>
          <div className="section-head" style={{ marginTop: 0 }}>Preview Mapping — {preview.count} form (Deposit {preview.deposit}, Withdraw {preview.withdraw})</div>
          {preview.warnings.length > 0 && (
            <ul data-testid="preview-warnings" style={{ color: "#c62828", fontSize: 11, margin: "0 0 8px 16px" }}>
              {preview.warnings.map((w, i) => <li key={i}>⚠ {w}</li>)}
            </ul>
          )}
          {preview.warnings.length === 0 && <div style={{ color: "#2e7d32", fontSize: 11, marginBottom: 6 }}>✓ Semua kolom penting terdeteksi.</div>}
          <div style={{ fontSize: 11, color: "#555", marginBottom: 6 }}>Kolom terbaca: {preview.columns.join(", ")}</div>
          <table className="panel-table" data-testid="preview-table">
            <thead><tr><th>User</th><th>Type</th><th className="text-right">Amount</th><th>Bank Asal</th><th>Info</th><th>Expected</th></tr></thead>
            <tbody>
              {preview.rows.map((r, i) => (
                <tr key={i}>
                  <td>{r.user}</td><td>{r.type}</td>
                  <td className="text-right">{Number(r.amount).toLocaleString("en-US")}</td>
                  <td>{r.bank || <span className="muted">(kosong)</span>}</td>
                  <td className="info-cell">{r.info}</td>
                  <td>{r.expected}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="section-head">Dataset Tersimpan</div>
      <table className="panel-table" data-testid="datasets-table">
        <thead>
          <tr><th>Nama Dataset</th><th>Mutasi</th><th>Form</th><th className="text-center">Jumlah Form</th>
            <th className="text-center">Deposit</th><th className="text-center">Withdraw</th><th>Durasi Asli</th><th>Aksi</th></tr>
        </thead>
        <tbody>
          {datasets.length === 0 && <tr className="empty-row"><td colSpan={8}>Belum ada dataset</td></tr>}
          {datasets.map((d) => (
            <tr key={d.id} data-testid={`dataset-row-${d.id}`}>
              <td><b>{d.name}</b></td>
              <td>{d.mutasi_filename || <span className="muted">-</span>}</td>
              <td>{d.form_filename}</td>
              <td className="text-center">{d.form_count}</td>
              <td className="text-center">{d.deposit_count}</td>
              <td className="text-center">{d.withdraw_count}</td>
              <td>{mins(d.original_duration_seconds)}</td>
              <td><a className="link-blue" onClick={() => del(d)} data-testid={`ds-del-${d.id}`}>Hapus</a></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
